import axios from 'axios';

const API_BASE_URL = 'https://app.rental.itup.com.br';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 45000,
});

export function changeFirstPassword({ token, email, password, passwordConfirm }) {
  return api.post('/rental_auth/api/customer-auth/first-login-change', {
    param: token,
    email,
    password,
    passwordConfirm,
  });
}

export function changeFirstPasswordManual({
  aliasAccess,
  username,
  oldPassword,
  password,
  passwordConfirm,
}) {
  return api.post('/rental_auth/api/customer-auth/first-login-change', {
    aliasAccess,
    username,
    oldPassword,
    password,
    passwordConfirm,
  });
}

export function getFirstLoginInfo({ token }) {
  return api.post('/rental_auth/api/customer-auth/first-login-info', {
    param: token,
  });
}

export default api;
